import { useCallback, useRef } from 'react'
import { useSelector } from 'react-redux'
import { messagesSelectors } from 'store/messages'
import { useGetChat } from 'api/chats'
import { useSendBotQuestion } from 'hooks/useSendBotQuestion'
import { ChatDetail } from 'components/chats/ChatDetail'
import { ChatBottomBar } from 'components/ChatBottomBar'
import { ChatTextInput } from 'components/ChatTextInput'
import { ChatPageHeader } from 'components/chat-page/ChatPageHeader'
import { ChatHero } from 'components/chat-page/ChatHero'
import { Spinner } from 'components/ui/Spinner'

type ChatMainAreaProps = {
  areaId?: string
}

export const ChatMainArea = ({ areaId }: ChatMainAreaProps) => {
  const chatId = useSelector(messagesSelectors.chatId)
  const currentChat = useSelector(messagesSelectors.currentChat)
  const { sendQuestion } = useSendBotQuestion()

  useGetChat(chatId)

  const pendingQuestionRef = useRef<string | undefined>(undefined)

  const onMessagesLoaded = useCallback(() => {
    const question = pendingQuestionRef.current
    if (question) {
      pendingQuestionRef.current = undefined
      sendQuestion(question).catch(console.error)
    }
  }, [sendQuestion])

  if (!chatId) {
    return (
      <ChatHero
        areaId={areaId}
        onPendingQuestion={(question) => {
          pendingQuestionRef.current = question
        }}
        onPendingCancelled={() => {
          pendingQuestionRef.current = undefined
        }}
      />
    )
  }

  if (!currentChat) {
    return (
      <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center">
        <Spinner />
      </div>
    )
  }

  return (
    <>
      <ChatPageHeader />
      <div className="tw-relative tw-mx-auto tw-flex tw-w-full tw-max-w-3xl tw-min-h-0 tw-flex-1 tw-flex-col tw-px-2 lg:tw-px-4">
        <ChatDetail subscribeUserChannel={false} onMessagesLoaded={onMessagesLoaded} />
        <ChatBottomBar surface="page">
          <ChatTextInput />
        </ChatBottomBar>
      </div>
    </>
  )
}
